import { FormControl, AbstractControl, FormGroup } from '@angular/forms';

import * as appConfig from '../../app.config';

export function atLeastOneLang(input: FormControl) {
    const root = input.root as FormGroup;
    if (!root || !root.controls) {
        return null;
    }

    const validator = new LangValidator(input, root);
    const result = validator.validate();

    return result ? null : { noLanguagesFilled: true };

    /*     const exactMatch = root.controls.password === input.value;
        return exactMatch ? null : { mismatchedPassword: true }; */
}

class LangValidator {
    private _c: AbstractControl;
    private _formGroup: FormGroup;

    constructor(c: AbstractControl, formGroup: FormGroup) {
        this._c = c;
        this._formGroup = formGroup;
    }

    private _getControlName(): string | null {
        return Object.keys(this._formGroup.controls).find(name => this._c === this._formGroup.controls[name]) || null;
    }

    private _getDerivedName(name: string): string | null {
        return name.split('_').slice(0, -1).join('_');
    }

    public validate(): boolean {
        const name = this._getControlName();
        const derivedName = this._getDerivedName(name);
        return this._validate(derivedName);
    }

    private _validate(field: string): boolean {
        let isValid = false;
        const langs = appConfig.languages;
        langs.forEach(lang => {
            const control = this._formGroup.get(field + '_' + lang);
            if (control && control.value && control.value.length > 0) {
                isValid = true;
            }
        });

        return isValid;
    }
}
